import React from 'react';
import stepsBack from "@assets/images/stepsBack.jpg";
import { useTranslation } from 'react-i18next';
const AdviseMeHeader = ({selectedTags,user}) => {
  const {t} = useTranslation();
    return (
     <div
        className="block rounded-[12px] p-6 text-white bg-cover"
        style={{ backgroundImage: `url(${stepsBack})` }}
      >
        <div className="flex flex-col justify-center p-4">
          <p className="text-[16px] lg:text-[20px] font-[Lato] font-[600]">
            Hi <span className="text-white text-justify">{user?.name}</span>
            ,<br />
            {/* {selectedTags.adviseMeDescription ? (
              <span className="text-[16px] lg:text-[18px] font-[Lato] font-[500]">
                {selectedTags.adviseMeDescription}
              </span>
            ) : ( */}
              <span className="text-[16px] lg:text-[18px] font-[Lato] font-[500]">
              {t("firstFormSteps.adviseMeDescription")}
              </span>
            {/* )} */}
          </p>
        </div>
      </div>
    );
}

export default AdviseMeHeader;
